import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause--sprite",
  "use": "pause--sprite-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol viewBox=\"0 0 56 56\" id=\"pause--sprite\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM17 15H22V41H17V15ZM34 15H39V41H34V15Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol